<template>
	<div>
		<v-snackbar v-model="snackbar.show" top :color="snackbar.color" :timeout="snackbar.timeout">
			{{ snackbar.message }}
			<v-btn :color="snackbar.buttonColor" flat @click="snackbar.show = false"> Close </v-btn>
		</v-snackbar>

		<loading-modal v-if="isLoading" :loading-text="`Loading ${$term('positionTemplate', { case: 'title' })}...`" />
		
		<position-template-editor 
			v-else-if="positionTemplate != null" 
			:positionTemplate="positionTemplate">
		</position-template-editor>

		<div v-else>
			{{ $term('positionTemplate', { case: 'title' }) }} could not be found
		</div>
	</div>
</template>

<script>
	import PositionTemplateEditor from '@/components/positionTemplate/PositionTemplateEditor';
	import LoadingModal from '@/components/LoadingModal';

	export default {
		name: 'PagePositionTemplateEdit',
		props: {
			id: {
				required: true
			}
		},
		data() {
			return {
				positionTemplate: null,
				isLoading: false,
				snackbar: {
					show: false,
					message: '',
					color: undefined,
					buttonColor: 'pink',
					timeout: 6000
				},
			};
		},
		components: {
			PositionTemplateEditor,
			LoadingModal
		},
		methods: {
			onCancel() {
				window.history.back();
			},
			showSnackbar(message, isError) {
				this.snackbar.show = true;
				this.snackbar.message = message;
				this.snackbar.color = isError ? 'error' : undefined;
				this.snackbar.buttonColor = isError ? '#fff' : 'pink';
				this.snackbar.timeout = isError ? 0 : 6000;
			},
		},
		created() {
			this.$store.dispatch('setPageTitle', `Edit ${this.$term('positionTemplate', { case: 'title' })}`);

			this.isLoading = true;
			this.$store.dispatch('positionTemplates/getById', this.id).then(
				(positionTemplate) => {
					this.isLoading = false;
					this.positionTemplate = positionTemplate;
				},
				(error) => {
					this.isLoading = false;
					this.showSnackbar(`An error occurred loading ${this.$term('positionTemplate')}`, true);
				}
			);
		}
	};
</script>

<style></style>
